/* eslint-disable new-cap */
import { useState, useRef } from 'react';
import { useInterval } from 'react-use';
import type { OneTrustClient } from '../types';

type useOneTrustReturn = [OneTrustClient | undefined, boolean];

type useOneTrustOptions = {
  onConsentChanged?: (event: CustomEvent) => void;
};

/**
 * Polls window.OneTrust until something shows up, and then returns.
 *
 * TODO: Check if we can init manually and "know" exactly when the lib has been setup.
 */
const useOneTrust = ({
  onConsentChanged,
}: useOneTrustOptions = {}): useOneTrustReturn => {
  const [isReady, setIsReady] = useState<boolean>(false);
  const ref = useRef<OneTrustClient | undefined>(undefined);
  const count = useRef<number>(0);

  useInterval(
    () => {
      if (!window?.OneTrust) {
        count.current = count.current + 1;
        return;
      }

      ref.current = window.OneTrust;

      if (onConsentChanged && typeof onConsentChanged === 'function') {
        ref.current.OnConsentChanged(onConsentChanged);
      }

      setIsReady(true);
    },
    !isReady && count.current < 10 ? 250 : null,
  );

  return [ref.current, isReady];
};

export default useOneTrust;
